// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f888c016","453":"dcab1b6a","667":"e4efb44f"}[chunkId] + ".chunk.js";
};